// extracted by mini-css-extract-plugin
export default {"OngletActif":"OngletsBoutons_OngletActif__4hQwr","Onglet":"OngletsBoutons_Onglet__Et6p-"};